
document.addEventListener("DOMContentLoaded", () => {
    // Handle bottle package option selection
    var selling_plan = document.getElementsByClassName('package-option selected')[0].getAttribute('selling-plans');
    document.getElementById('selling_plan').value = selling_plan;
  console.log(selling_plan);
    document.querySelector('.product-variant-id').value = document.getElementsByClassName('package-option selected')[0].getAttribute('variant-id');
    //setCookie('PackageSelection', 'subscription', 1); // Default cookie as Subs
    setCookie('Selling_plan', selling_plan, 1); // Lasts 1 days
  
    document.querySelectorAll('.package-option').forEach(option => {
      option.addEventListener('click', function () {
        document.querySelectorAll('.package-option').forEach(o => o.classList.remove('selected'));
        this.classList.add('selected');
        document.getElementsByClassName('box_bottle_img')[0].src= option.getAttribute('variant-image');
        
        var selectedVariantId = option.getAttribute('variant-id');
        var selectedSellingPlanId = option.getAttribute('selling-plans');
        let PackageSelection = getCookie('PackageSelection');
         setCookie('Selling_plan', selectedSellingPlanId, 1);
        if(PackageSelection == 'subscription'){
         
          document.getElementById('selling_plan').value = selectedSellingPlanId;
          document.querySelector('.product-variant-id').value = selectedVariantId;
          document.getElementsByClassName('save_price')[0].textContent= option.getAttribute('metafield-DiscountbadgeSubscription');
          document.getElementsByClassName('per_bottle')[0].textContent= option.getAttribute('metafield-MonthlySubsription');
          document.getElementsByClassName('compare_price')[0].textContent= option.getAttribute('compare-price');
          
        }else{
          document.querySelector('.product-variant-id').value = selectedVariantId;
          document.getElementsByClassName('save_price')[0].textContent= option.getAttribute('metafield-DiscountbadgeMonthly');
          document.getElementsByClassName('per_bottle')[0].textContent= option.getAttribute('metafield-MonthlyOnetime');
          document.getElementsByClassName('compare_price')[0].textContent= option.getAttribute('compare-price');
        }
      });
    });
    function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}
    // Handle purchase subscription option selection
    document.querySelectorAll('.purchase-options div').forEach(option => {
      option.addEventListener('click', function () {  
        document.querySelectorAll('.purchase-options div').forEach(o => o.classList.remove('selected'));
        this.classList.add('selected');
        let Selling_plan = getCookie('Selling_plan');
        PackageSelection = getCookie('PackageSelection');
        if (this.classList.contains('subscription')) {
           setCookie('PackageSelection', 'subscription', 1);
           document.getElementById('selling_plan').value = Selling_plan;

          document.getElementsByClassName('save_price')[0].textContent= document.getElementsByClassName('package-option selected')[0].getAttribute('metafield-DiscountbadgeSubscription');
          document.getElementsByClassName('per_bottle')[0].textContent= document.getElementsByClassName('package-option selected')[0].getAttribute('metafield-MonthlySubsription');
         
          }else{
          
          setCookie('PackageSelection', 'onetime', 1);
        
          document.getElementById('selling_plan').value = "";

          document.getElementsByClassName('save_price')[0].textContent= document.getElementsByClassName('package-option selected')[0].getAttribute('metafield-DiscountbadgeMonthly');
          document.getElementsByClassName('per_bottle')[0].textContent= document.getElementsByClassName('package-option selected')[0].getAttribute('metafield-MonthlyOnetime');
         
          }
       
      });
    });
  
  });



document.addEventListener('DOMContentLoaded', function () {

  const form = document.querySelector('.custom-product-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.disabled = true;
    submitButton.classList.add('loading');

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err; });
      }
      return response.json();
    })
    .then(data => {

      // 🔹 Refresh cart drawer section
      return fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
    })
    .then(response => response.text())
    .then(html => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      const mainDrawer = document.querySelector('drawer ');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      // 🔹 Open Drawer (Dawn / similar themes)
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('drawer')) {
        drawer.classList.add('active');
        currentDrawer.classList.remove('is-empty');
      }

      // 🔹 Update cart icon bubble
      updateCartCount();

    })
    .catch(error => {
      alert(error.description || 'Something went wrong');
      console.error('Cart Error:', error);
    })
    .finally(() => {
      submitButton.disabled = false;
      submitButton.classList.remove('loading');
    });

  });


  // 🔹 Update cart count bubble
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const bubbles = document.querySelectorAll('.cart-count-bubble span');
        bubbles.forEach(bubble => {
          bubble.textContent = cart.item_count;
        });
      });
  }

});